import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons/CheckIcon';

/**
 * The blue "Copied to clipboard" pill, after the prototype. It is not a live region: `variant_1`
 * renders it with the sheet, so the dialog's content already reads it, and the `variant_2` steps
 * announce the copy in the sheet's own live regions.
 */
export const CopiedPill: React.FC<{ label: string }> = ({ label }) => (
	<Text
		as="p"
		size="small"
		fontWeight="bold"
		className="bg-fill-selected-strong text-typography-inverse-strong-fixed flex items-center gap-1.5 rounded-full px-4 py-1.5 whitespace-nowrap"
		data-testid="facebook-post-sheet-copied-pill"
	>
		<CheckIcon size="small" />
		{label}
	</Text>
);
